export default {
  GET_ONE_ATTACHMENT(state) {
    return state.single_attachment
  },
}
